import { gql } from '@apollo/client';

const STARR_ELIGIBILITY = gql`
  query StarrEligibility($accountId: String!) {
    starrEligibility(accountId: $accountId) {
      checks {
        name
        pass
      }
      eligible
    }
  }
`;

export { STARR_ELIGIBILITY };
